/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsUserControllerGetContactsQueryResponse,
  TelegramProductsUserControllerGetContactsPathParams,
  TelegramProductsUserControllerGetContactsQueryParams,
  TelegramProductsUserControllerGetContacts401,
} from '../../types/TelegramProductsUserControllerGetContacts.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramProductsUserGetContacts } from '../../methods/telegramProductsUserGetContacts.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramProductsUserGetContactsQueryKey = (
  link: TelegramProductsUserControllerGetContactsPathParams['link'],
  params?: TelegramProductsUserControllerGetContactsQueryParams,
) =>
  [{ url: '/api/user/telegram/products/:link/contacts', params: { link: link } }, ...(params ? [params] : [])] as const;

export type TelegramProductsUserGetContactsQueryKey = ReturnType<typeof telegramProductsUserGetContactsQueryKey>;

export function telegramProductsUserGetContactsQueryOptions(
  link: TelegramProductsUserControllerGetContactsPathParams['link'],
  params?: TelegramProductsUserControllerGetContactsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramProductsUserGetContactsQueryKey(link, params);
  return queryOptions<
    TelegramProductsUserControllerGetContactsQueryResponse,
    ResponseErrorConfig<TelegramProductsUserControllerGetContacts401>,
    TelegramProductsUserControllerGetContactsQueryResponse,
    typeof queryKey
  >({
    enabled: !!link,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramProductsUserGetContacts(link, params, config);
    },
  });
}

/**
 * {@link /api/user/telegram/products/:link/contacts}
 */
export function useTelegramProductsUserGetContacts<
  TData = TelegramProductsUserControllerGetContactsQueryResponse,
  TQueryData = TelegramProductsUserControllerGetContactsQueryResponse,
  TQueryKey extends QueryKey = TelegramProductsUserGetContactsQueryKey,
>(
  link: TelegramProductsUserControllerGetContactsPathParams['link'],
  params?: TelegramProductsUserControllerGetContactsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramProductsUserControllerGetContactsQueryResponse,
        ResponseErrorConfig<TelegramProductsUserControllerGetContacts401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramProductsUserGetContactsQueryKey(link, params);

  const query = useQuery(
    {
      ...telegramProductsUserGetContactsQueryOptions(link, params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramProductsUserControllerGetContacts401>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
